module.exports = __webpack_public_path__ + "static/img/bellini-bliss-m.f0ddf98.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/bellini-bliss-m.jpg
// module id = pyMR
// module chunks = 0